/* Teksty interfejsu: assets/json/i18n/{lang}/js-runtime.json. */
function jst(key, params) {
    var api = typeof globalThis !== 'undefined' ? globalThis.PewniakiI18n : null;
    if (api && typeof api.t === 'function') return api.t(key, params);
    if (typeof module === 'object' && module.exports && typeof require === 'function') {
        var lang = typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'en' : 'pl';
        var dict = require('../../json/i18n/' + lang + '/js-runtime.json');
        var text = Object.prototype.hasOwnProperty.call(dict, key) ? String(dict[key]) : key;
        return (params || []).reduce(function (out, value, index) { return out.split('%' + (index + 1)).join(String(value)); }, text);
    }
    return key;
}

/** Zapisane zestawy analizatora: porównanie cech i plik JSON.
 *  Od Fali 1 (24.09.2026) na wspólnym magazynie „Moje kupony”
 *  (assets/js/moje-zestawy.js, klucz pewniaki:moje-zestawy:v2) — te same zestawy
 *  widzą generator, sprawdzarka kuponu i strona wyników. Dawny klucz
 *  pewniaki:analizator:v1:<gra> przenosi migracja modułu (bez kasowania). */
(function(root,doc){
  'use strict';
  function en(pl,enText){return /^en(?:-|$)/i.test(doc.documentElement.lang||'')?enText:pl;}
  function el(tag,cls,text){var x=doc.createElement(tag);if(cls)x.className=cls;if(text!==undefined)x.textContent=text;return x;}
  function start(){
    var page=doc.querySelector('[data-analizator-root]'),box=doc.querySelector('[data-zapisane-zestawy]');if(!page||!box)return;
    var game=page.dataset.gra||'lotto',pool=Number(page.dataset.pula),pick=Number(page.dataset.typuje);
    var fields=page.querySelectorAll('[data-zestaw-liczba]'),name=box.querySelector('[data-zapis-nazwa]'),status=box.querySelector('[data-zapis-status]'),target=box.querySelector('[data-zapis-tabela]');
    function message(t,bad){status.textContent=t;status.className=bad?'blad-pola':'podpowiedz';}
    var MZ=root.PewniakiZestawy,S=MZ&&typeof MZ.sklep==='function'?MZ.sklep():null;
    if(!S||!S.reguly(game)){message(jst("pages_analizator_zestawy_js.3bb649bd42ef"),true);return;}
    function valid(numbers){if(!Array.isArray(numbers)||numbers.length!==pick)return false;var seen={};for(var i=0;i<numbers.length;i++){var n=Number(numbers[i]);if(!Number.isInteger(n)||n<1||n>pool||seen[n])return false;seen[n]=true;}return true;}
    function current(){var out=[];for(var i=0;i<fields.length;i++){if(String(fields[i].value).trim()==='')return null;out.push(Number(fields[i].value));}return valid(out)?out.sort(function(a,b){return a-b;}):null;}
    function cell(row,tag,text){var c=el(tag,'',text);if(tag==='th')c.scope='row';row.appendChild(c);return c;}
    function bladZapisu(b){
      if(b==='duplikat')return jst("pages_analizator_zestawy_js.b8cc26cd732a");
      if(b==='limit')return jst("pages_analizator_zestawy_js.925f763137b5");
      if(b==='niedostepny')return jst("pages_analizator_zestawy_js.b91af8b76462");
      if(b==='miejsce')return jst("pages_analizator_zestawy_js.836651dfe504");
      return jst("pages_analizator_zestawy_js.2aa7d863172a");
    }
    var otwarte=false;
    function render(){
      var sets=S.lista(game);
      while(target.firstChild)target.removeChild(target.firstChild);
      if(!sets.length){target.appendChild(el('p','tekst-maly',jst("pages_analizator_zestawy_js.cbf425014774")));return;}
      if(!otwarte){otwarte=true;S.zdarzenie('my_ticket_open',game,'analizator',sets.length);}
      var table=el('table','tabela'),cap=el('caption','',jst("pages_analizator_zestawy_js.347b92c59f6b")),head=el('thead'),hr=el('tr');
      [jst("pages_analizator_zestawy_js.44914836bfb9"),jst("pages_analizator_zestawy_js.030facd3e385"),jst("pages_analizator_zestawy_js.be5a31e97d39"),jst("pages_analizator_zestawy_js.7a06ab1ab8a2"),jst("pages_analizator_zestawy_js.a7c45562a890"),jst("pages_analizator_zestawy_js.c76b3252902e"),jst("pages_analizator_zestawy_js.8bb8b0e00c50")].forEach(function(t){hr.appendChild(el('th','',t));});
      head.appendChild(hr);table.appendChild(cap);table.appendChild(head);
      var body=el('tbody');
      sets.forEach(function(s){
        // Zestaw innej długości (np. Multi Multi 1–10 z kuponu) nie ma tu cech —
        // analizator liczy je dla pełnego zestawu o rozmiarze losowania.
        var w=s.numbers.length===pick?root.PEWNIAKI_ANALIZATOR_CECHY.model({pula:pool,typuje:pick,zestaw:s.numbers}):null,tr=el('tr');
        tr.dataset.zapisId=s.id;cell(tr,'th',s.name);
        var kc=cell(tr,'td');kc.setAttribute('data-sort',s.numbers.map(function(n){return String(n).padStart(3,'0');}).join(''));
        kc.appendChild(MZ.kule(doc,/^en(?:-|$)/i.test(doc.documentElement.lang||''),game,s,null));
        ['suma','rozpietosc','parzyste','wysokie'].forEach(function(k){cell(tr,'td',w?String(w[k]):'—');});
        var td=cell(tr,'td',''),btn=el('button','przycisk',jst("pages_analizator_zestawy_js.c21b8cf72bed"));btn.type='button';btn.dataset.zapisUsun=s.id;td.appendChild(btn);
        body.appendChild(tr);
      });
      table.appendChild(body);target.appendChild(table);
    }
    box.querySelector('[data-zapis-dodaj]').addEventListener('click',function(){
      var numbers=current();
      if(!numbers){message(jst("pages_analizator_zestawy_js.0ac4b89892e1"),true);return;}
      var r=S.dodaj(game,{liczby:numbers,nazwa:name.value},'analizator');
      if(!r.ok){message(bladZapisu(r.blad),true);return;}
      S.zdarzenie('my_ticket_save',game,'analizator',r.liczba);
      message(jst("pages_analizator_zestawy_js.043a418c4726"),false);name.value='';
    });
    target.addEventListener('click',function(e){
      var id=e.target&&e.target.dataset?e.target.dataset.zapisUsun:null;if(!id)return;
      var r=S.usun(game,id);
      message(r.ok?jst("pages_analizator_zestawy_js.ae7d6a41f0df"):bladZapisu(r.blad),!r.ok);
    });
    box.querySelector('[data-zapis-eksport]').addEventListener('click',function(){
      var blob=new Blob([JSON.stringify(S.eksport(game),null,2)],{type:'application/json'}),url=URL.createObjectURL(blob),a=doc.createElement('a');
      a.href=url;a.download='pewniaki-'+game+'-zestawy.json';doc.body.appendChild(a);a.click();a.remove();setTimeout(function(){URL.revokeObjectURL(url);},0);
      message(jst("pages_analizator_zestawy_js.36de84e7f338"),false);
    });
    box.querySelector('[data-zapis-import]').addEventListener('change',function(e){
      var file=e.target.files&&e.target.files[0];if(!file)return;var reader=new FileReader();
      reader.onload=function(){
        var d=null;try{d=JSON.parse(String(reader.result||''));}catch(err){d=null;}
        var w=d?S.importuj(game,d):{blad:'format'};
        if(w.blad==='format'){message(jst("pages_analizator_zestawy_js.492da0c935f0"),true);}
        else if(w.zapisane>0){message(jst("pages_analizator_zestawy_js.80d2f40b2a9e")+w.zapisane+'.',false);}
        else if(w.blad==='duplikat'){message(jst("pages_analizator_zestawy_js.18f74622c7a8"),false);}
        else{message(bladZapisu(w.blad),true);}
        e.target.value='';
      };
      reader.readAsText(file);
    });
    doc.addEventListener(MZ.ZDARZENIE,function(e){if(!e.detail||!e.detail.game||e.detail.game===game)render();});
    render();
  }
  if(doc.readyState==='loading')doc.addEventListener('DOMContentLoaded',start);else start();
})(window,document);
